module.exports = __webpack_public_path__ + "img/flag2.049ed135.gif";